module.exports = __webpack_public_path__ + "static/media/物体追踪小车.4a160719.png";